import { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import AppTextField from '../../../../components/common/forms/AppTextField';
import AppSelect from '../../../../components/common/forms/AppSelect';
import PageContainer from '../../../../components/common/PageContainer';
import { ICreatePartsDescription } from './utils/PartsDescription-utils';
import { SelectOptionType } from '../../../../components/common/forms/form-types';
import { PartsDescriptionSchema, PartsDescriptionInitialValues } from './utils/schema';
import { useGetsPartsDescriptionById, useUpdatePartsDescriptions, useCreatePartsDescriptions } from '../../../../hooks/usePartsDescription';
import { appColors, appStyles } from '../../../../theme';
import { usePermission } from "../../../../hooks/usePermissions";
import { Modules, Permissions } from "../../../Users/Roles/roles-utils";
import { Navigate } from 'react-router-dom';

const PartsDescriptionForm = () => {
  const hasAddPermission = usePermission(
    Modules.mmdPd.accessKey,
    Permissions.add
  );
  const hasEditPermission = usePermission(
    Modules.mmdPd.accessKey,
    Permissions.edit
  );
  const navigate = useNavigate();
  const currentPartsDescription = useGetsPartsDescriptionById();
  const updatePartsDescription = useUpdatePartsDescriptions();
  const createPartsDescription = useCreatePartsDescriptions();
  const statusOptions: SelectOptionType[] = [{'id': 'true', 'label': 'Active' , 'value': 'true'},{'id': 'false', 'label': 'Inactive' , 'value': 'false'} ]
const { register, 
        handleSubmit,
        setValue,
        control,
        formState: { errors, isValid }
      } = useForm<ICreatePartsDescription>({
        defaultValues: currentPartsDescription.data! ? currentPartsDescription.data : PartsDescriptionInitialValues,
        mode: 'onChange',
        resolver: yupResolver(PartsDescriptionSchema),
      });

  useEffect(() => {
    setValue("isActive", 'true');
    if (!currentPartsDescription.data) return;
    setValue("description", currentPartsDescription.data?.description);
    setValue("isActive", currentPartsDescription.data?.isActive ? 'true' : 'false');
  }, [currentPartsDescription.data, setValue]);

  if (!hasAddPermission && !hasEditPermission) return <Navigate to="/home" />;

  const onError = (err: typeof errors) => {
    console.error(err);
  };

  const onSubmit = (data : ICreatePartsDescription) => {
    if (currentPartsDescription.data) {
      updatePartsDescription.mutate(data);
    }
    else {
      createPartsDescription.mutate(data)
    }
  };

  const backTo = () => navigate('/parts-description');
  
  return (
    <>
      <PageContainer
        title='Manage My Databases'
        subTitle='Parts Description'
        controls={
          <Stack direction='row' gap={2}>
            <Button sx={{ backgroundColor: appColors.lightGray, color: 'black' }} onClick={backTo}>
              Cancel
            </Button>
            <Button
              onClick={handleSubmit(onSubmit, onError)}
              disabled={!isValid }
              disableElevation
              variant='contained'
              sx={{ textTransform: 'capitalize', borderRadius: 1.5 }}
            >
              Save
            </Button>
          </Stack>
        }
      >
        <Divider color='black' />
        <Stack
          component='form'
          height='100%'
          bgcolor='white'
          py={3}
          boxShadow={appStyles.shadow}
          borderRadius={1}
        >
          <Stack px={3} height='100%' overflow='auto' gap={1}>
          <Stack direction="row" justifyContent="space-between" width="100%" mt={3}>
            <Stack direction="column" gap={1.5} width="45%">   
              <AppTextField
                label="Description"
                labelAlignment="left"
                labelWidth='33%'
                fieldWidth= '67%'
                fontWeight={400}
                placeholder="Description"
                error={!!errors.description}
                helperText={errors.description?.message}
                {...register('description')}
              />
                <Controller
                    control={control}
                    name='isActive'
                    render={({ field }) => (
                      <AppSelect
                        label="Status"
                        disabled= {currentPartsDescription.data ? false : true}
                        labelAlignment="left"
                        labelWidth='33%'
                        fieldWidth= '67%'
                        fontWeight={400}
                        placeholder="Select here"
                        error={!!errors.isActive}
                        helperText={errors.isActive?.message}
                        options={statusOptions}
                        {...register('isActive')}
                        {...field}
                      />
                  )}
                />

               
            </Stack>
          </Stack>
          </Stack>
        </Stack>
      </PageContainer>
      <Outlet />
    </>
  )
}

export default PartsDescriptionForm;